import React from 'react';
import { SimpleCheckboxBase } from '@/presentation/components';
import { IconCheckInput, IconCheckInputError, IconLampCharge } from '@/presentation/components/icons';
import Styles from './question-styles.scss';
import { orderArrayByOrden } from '@/presentation/utils/order-utils';
// main component
const QuestionResult = ({ question, answers, showCorrectAnswers = false }) => {
    var _a;
    const getStateAnswer = (answer) => {
        var _a;
        const questionResult = answers.find(i => (i === null || i === void 0 ? void 0 : i.idQuestion) === (question === null || question === void 0 ? void 0 : question.id));
        // the question didn't exist in the quiz
        if (!questionResult)
            return 'NONE';
        const wasMarked = (_a = questionResult === null || questionResult === void 0 ? void 0 : questionResult.idAnswers) === null || _a === void 0 ? void 0 : _a.includes(answer === null || answer === void 0 ? void 0 : answer.id);
        if (answer === null || answer === void 0 ? void 0 : answer.correct) {
            if (showCorrectAnswers)
                return 'GOOD';
            else
                return wasMarked ? 'GOOD' : 'NONE';
        }
        else
            return wasMarked ? 'BAD' : 'NONE';
    };
    const validateQuestionType = () => {
        var _a, _b;
        return ((_b = (_a = question === null || question === void 0 ? void 0 : question.type) === null || _a === void 0 ? void 0 : _a.description) === null || _b === void 0 ? void 0 : _b.toLocaleLowerCase()) === 'checkbox';
    };
    return (React.createElement("div", null,
        React.createElement("div", { className: "d-flex align-items-center" },
            React.createElement("div", null,
                React.createElement(IconLampCharge, null)),
            React.createElement("div", { className: Styles.title }, question === null || question === void 0 ? void 0 : question.description)),
        React.createElement("div", { className: Styles.body }, (_a = orderArrayByOrden(question === null || question === void 0 ? void 0 : question.answers)) === null || _a === void 0 ? void 0 : _a.map((item, key) => {
            const localState = getStateAnswer(item);
            return (React.createElement("div", { className: "d-flex align-items-center p-1", key: `${item === null || item === void 0 ? void 0 : item.id}_${key}` },
                validateQuestionType() ? (React.createElement(SimpleCheckboxBase, { inputWrapItem: getClassInput(localState), readOnly: true, overrideIcon: getIcon(localState), defaultChecked: true })) : (getRadioIcon(localState)),
                React.createElement("div", { className: Styles.answer, style: { color: getColor(localState) } }, item === null || item === void 0 ? void 0 : item.description)));
        }))));
};
const getRadioIcon = (state) => {
    if (state === 'NONE')
        return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("circle", { cx: "12", cy: "12", r: "11", fill: "white", stroke: "#EEEEEE", strokeWidth: "2" })));
    if (state === 'BAD')
        return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("rect", { width: "24", height: "24", rx: "12", fill: "#EC526E" }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.6129 7.2097C8.22061 6.90468 7.65338 6.93241 7.29289 7.29289C6.90237 7.68342 6.90237 8.31658 7.29289 8.70711L10.5858 12L7.29289 15.2929L7.2097 15.3871C6.90468 15.7794 6.93241 16.3466 7.29289 16.7071C7.68342 17.0976 8.31658 17.0976 8.70711 16.7071L12 13.4142L15.2929 16.7071L15.3871 16.7903C15.7794 17.0953 16.3466 17.0676 16.7071 16.7071C17.0976 16.3166 17.0976 15.6834 16.7071 15.2929L13.4142 12L16.7071 8.70711L16.7903 8.6129C17.0953 8.22061 17.0676 7.65338 16.7071 7.29289C16.3166 6.90237 15.6834 6.90237 15.2929 7.29289L12 10.5858L8.70711 7.29289L8.6129 7.2097Z", fill: "white" })));
    if (state === 'GOOD')
        return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("rect", { width: "24", height: "24", rx: "12", fill: "#65C702" }),
            React.createElement("path", { d: "M7 12L9.2598 15.0131C9.64114 15.5215 10.3939 15.5499 10.8124 15.0716L17 8", stroke: "white", strokeWidth: "2", strokeLinecap: "round" })));
};
const getIcon = (state) => {
    if (state === 'NONE')
        return null;
    if (state === 'BAD')
        return React.createElement(IconCheckInputError, null);
    if (state === 'GOOD')
        return React.createElement(IconCheckInput, null);
};
const getClassInput = (state) => {
    if (state === 'NONE')
        return Styles.inputWrapItemWhite;
    if (state === 'BAD')
        return Styles.inputWrapItemError;
    if (state === 'GOOD')
        return Styles.inputWrapItemSuccess;
};
const getColor = (state) => {
    if (state === 'NONE')
        return '#bbb';
    if (state === 'BAD')
        return '#EC526E';
    if (state === 'GOOD')
        return '#65C702';
};
export default QuestionResult;
